import React from "react";
import {toolList,undoRedoList} from '../../constants/toolbar';
import {showSnackbar} from '../../utils/snackbar';
import {enableTool,selectTool, uploadImage, createNewPage, resetZoom, copySelectedDrawing, pasteSelectedDrawing,openGallery, saveCropSelectionDetails} from "../../actions/wizard";
import { connect } from "react-redux";
import template from '../../templates.json';
import TextDecor  from "components/TextDecor";
import { fabric } from 'fabric';
import { ReactComponent as CropIcon } from '../../assets/icons/crop.svg';
import TableMenu from "./TableComponent/TableMenu";
// @ts-nocheck

class Toolbar extends React.Component<any, any>{
    private inputRef;
    
    constructor(props){
        super(props);
        this.state = {
            isOpen: false,
            submenuOpen: false,
            submenuPosition: { top: 0, left: 0 }, // To store submenu position
          };
        
        // @ts-ignore
        this.inputRef= React.createRef();
        //@ts-ignore
        this.dropDownEle= React.createRef();
        //@ts-ignore
        this.dropdownRef = React.createRef();
        //@ts-ignore
        this.submenuRef = React.createRef();
    }
    componentDidMount(){
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    createNewPage= (pageType, pageName, pageNumber, projectData)=>{
        try {
            const {roomDetails} = projectData;
            let  roomId = Object.keys(roomDetails)[0], roomType = roomDetails[roomId]['roomType'];
            const {pages} = this.props;
            roomType = roomType ? roomType.toLowerCase() : "default";
            let page = Object.assign({},template.pages[roomType][pageType.toUpperCase()]) || {};
            if(Object.keys(page).length <=0)
                page = Object.assign({},template.pages[pageType.toUpperCase()]);
            let index =1;
            (pages || []).map(p=>{
                if((p.type && p.type.indexOf(page.type) !== -1))
                    index+=1;
                return p;
            })
            page.pageNumber = pageNumber;
            page.pageType = "created_page";
            page.name = `${page.name} ${index}`;
            let checkList = ["bespoke", "demolition","falseCeiling",
                            "electricalservices","plumbingservices","showercubicles",
                            "drapes&upholstery","countertopmaterial&services","renovation",
                            "paintingservice","wallpaperservice","flooringservice",
                            "lightingservice","loosefurnitures"]
            if(checkList.includes(pageType))
                page.type = `${page.type}${index}`
            // const newPage = {};
            // newPage[pageNumber] = page;
            this.props.createNewPage({newPage: page, pageNumber})
        } catch (error) {
            console.error("Error in createNewPage", error);
        }
    }
    handleUploadImage = (event) => {
           // this.props.imageData(event.target.files[0]);
           try {
            let target = event.target;
            const { pageDetails } = this.props;
            let {files} = target;
            if(!files || files.length <= 0 ){
                showSnackbar("Plese select images to upload!");
                return;
            }
            this.props.uploadImage({images: files, tag: pageDetails?.type.toLowerCase()});
            this.inputRef.current.value = '';
        } catch (error) {
            console.error("Error while uploading image in component", error);
        }
    }
    
    enableToolBar = (toolType, colour, toolEnabled)=>{
        try {
            if(toolType==='LOCAL_IMAGE'){
                this.inputRef.current.click();
            }
            else if(toolType==='SPACECRAFT_IMAGE'){
                this.props.openGallery(true);              
            }
            else{ 
            // @ts-ignore
            fabric.Canvas.prototype.setCursor= function () {
                let canvasEle = document.querySelector('.upper-canvas');
                 // @ts-ignore
                canvasEle.style.cursor = 'crosshair';
            };
            this.props.enableTool(toolType,colour, toolEnabled)
        }
        
        } catch (error) {
            console.error("Error in enableToolBar", error);
        }
    }
     // Close dropdown when clicking outside
     handleClickOutside = (event) => {
         if (
            // @ts-ignore
          this.dropdownRef.current && !this.dropdownRef.current.contains(event.target) && this.submenuRef.current &&  !this.submenuRef.current.contains(event.target)
        ) {
          this.setState({ isOpen: false, submenuOpen: false });
        }
      };

    handleOutsideClick = (e) =>{
        try {
            // @ts-ignore  
            if (this.dropDownEle.current) {
                // @ts-ignore
                let options = this.dropDownEle.current.closest('.toolOptionsWrapper');
                options = options.querySelector('.toolDropdownIcon');
                if(options){
                    // @ts-ignore
                    options.click();
                }
                    
               // alert('You clicked outside of me!');
            }
        } catch (error) {
            console.error("Error in handleOutsideClick");
        }
    }

    // Function to perform undo operation
    undo = () => {
        const canvas = this.props.fabricInstance;
        canvas.undo()
    };

    // Function to perform redo operation
    redo = () => {
        const canvas = this.props.fabricInstance;
        canvas.redo()
    };

    toggleDropdown = () => {
        this.setState((prevState) => ({
          isOpen: !prevState.isOpen,
          submenuOpen: false,
        }));
      };

    openSubmenu = (event, name) => {
        const submenuRect = event.target.getBoundingClientRect();
        console.log('submenuRect', submenuRect);
        
        this.setState({
          submenuOpen: name,
          submenuPosition: { top: submenuRect.top, left: submenuRect.right + 10 }, // Position outside the menu
        });
      };

    subMenuOptions = (options: any) => {
        const { submenuPosition } = this.state;
        return (
            <div className="subMenu_options"
                // @ts-ignore
                ref={this.submenuRef}
                style={{ top: submenuPosition.top, left: submenuPosition.left - 10 }}>
                {
                    options?.map((item: any, i: any) => (
                        <p className={`optionItem ${item?.showTag ? 'newPage_tag' : ''}`} key={i} onClick={() => {
                            (item.pageType === "newpage") ? this.createNewPage(item.toolType, item.name, this.props?.pages.length + 1, this.props.projectData)
                                : this.enableToolBar(item.toolType, item.color, true)
                        }}>
                            {item.name}
                            <div>
                                {item?.showTag ? <span>New</span> : ''}
                            </div>
                        </p>
                    ))
                }
            </div>
        )
    }


    render(){
        const {zoomValue} = this.props;
        const isZoomed = (zoomValue && zoomValue !== 1);
        const disableTool = this.props.pageDetails?.pageType === 'RFQ'
        return(
            <div className={'toolBarContainer'}>
                 <div id="pageDrawTools" className={`flexBox rightDivider ${isZoomed?'toolBarDisabled':''}`} 
                    title={isZoomed?"Please reset zoom to enable this":""}>
                    {toolList.map((tool, index) => {
                        const { SVG,type} = tool;
                        const {selectedTool} =this.props;
                        const selectedToolType = selectedTool ===tool.toolType? '':tool.toolType;                        
                        const disableIcon = disableTool && tool?.name !== 'File';
                        return (
                            <div key= {index} className={`tool toolIcon ${isZoomed || disableIcon?'toolBarDisabledIcon':''}`} onClick={()=>{type!=='dropdown'?
                                this.enableToolBar( tool.toolType ,'', true):this.props.selectTool(selectedToolType)}}>
                                {/*{tool.SVG == 'NA' && <span>{tool.name}</span>}*/}
                                <SVG className={'toolIcon'}/>
                                <input type="file" onChange={this.handleUploadImage} id="upload_image" ref={ this.inputRef } style={{display:'none'}}/>
                                {type === "dropdown" && (
                                    <div className={'toolOptionsWrapper'}>
                                        <span className={'toolDropdownIcon'}>
                                            <i className="fa fa-caret-down dropDownClose" />
                                        </span>
                                        
                                        {this.props.selectedTool=== tool.toolType &&
                                        // @ts-ignore
                                        <div className={'optionBox'} ref={this.dropDownEle}>
                                            {
                                                // @ts-ignore
                                                tool?.options?.sort((a, b) => a.name.localeCompare(b.name))?.map((item: any,i: any)=>{
                                                    const { SVG } = item;
                                                    return (
                                                        <div
                                                            className="option_listing"
                                                            onMouseEnter={(e) => this.openSubmenu(e, item.name)}
                                                            onMouseLeave={() => this.setState({ submenuOpen: false })}
                                                        >
                                                            <p className={`optionItem ${item?.showTag ? 'newPage_tag' : ''}`} key={i} onClick={() => {
                                                                if (item?.subMenu) {
                                                                    return
                                                                }
                                                                (item.pageType === "newpage") ? this.createNewPage(item.toolType, item.name, this.props?.pages.length + 1, this.props.projectData)
                                                                    : this.enableToolBar(item.toolType, item.color, true)
                                                            }}>
                                                                {SVG && <SVG className={'optionImage'} />}
                                                                {item.name}
                                                                <div>
                                                                    {item?.showTag ? <span>New</span> : ''}
                                                                    {item?.subMenu ? <i className="fa fa-caret-right" /> : ''}
                                                                </div>
                                                            </p>
                                                            {
                                                                item?.subMenu && this.state.submenuOpen === item?.name ? this.subMenuOptions(item?.subMenu) : ''
                                                            }
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                        }
                                    </div>
                                )}

                            </div>
                            )
                        })
                    }
                </div>
                <div id="drawingActionTools" className={`flexBox rightDivider ${disableTool?'toolBarDisabledIcon':''}`}>
                    <i className="fa fa-undo tool toolIcon" aria-hidden="true" title="Undo (Ctrl + Z)"
                        onClick={() => this.undo()}></i>
                    <i className="fa fa-repeat tool toolIcon" aria-hidden="true" title="Redo (Ctrl + Y)"
                        onClick={() => this.redo()}></i>
                    <i className="fa fa-files-o tool toolIcon" aria-hidden="true" title="Copy (Ctrl + c)"
                        onClick={this.props.copySelectedDrawing}></i>
                    <i className="fa fa-clipboard tool toolIcon" aria-hidden="true" title="Paste (Ctrl + v)"
                        onClick={this.props.pasteSelectedDrawing}></i>
                </div>
                {/* <div className="flexBox">
                    {
                        undoRedoList.map((tool, index) => {
                            const { SVG, ActiveSVG } = tool;
                            return (
                                <div key= {index} className={'tool toolIcon'} 
                                    onClick={()=>{this.enableToolBar(tool.toolType,'', true)}}>
                                    <SVG className={'toolIcon'}/>
                                </div>
                                )

                        }
                        )
                    }
                </div> */}
                <TableMenu />
                <TextDecor></TextDecor>                
                {/* <div id="pageZoomTools" className="flexBox">
                    {zoomIconList.map((tool, index) => {
                        const { SVG, ActiveSVG } = tool;
                        return (
                            <div key= {index} className={'tool toolIcon'} 
                                onClick={()=>{this.enableToolBar(tool.toolType,'', true)}}>
                                <SVG className={'toolIcon'}/>
                            </div>
                            )
                        })
                    }
                    {isZoomed
                    ?<div onClick={()=>{this.props.resetZoom()}} className={'resetButton'}>
                            {`Reset Zoom`}
                    </div>
                    :null}
                </div> */}
                </div>
        )
    }

}
export default connect(
    (state: any) => ({
        selectedTool:state.wizard.selectedTool,
        pages: state.wizard.pages,
        projectData: state.wizard.projectData,
        zoomValue: state.wizard.zoomValue,
        pageDetails: state.wizard.pageDetails,
        selectedCropImageDetails: state.wizard.selectedCropImageDetails,
        fabricInstance: state.wizard.fabricInstance,
        currentStateIndex: state.wizard.currentStateIndex
    }),
    {
        enableTool,
        selectTool,
        createNewPage,
        resetZoom,
        copySelectedDrawing,
        pasteSelectedDrawing,
        uploadImage,
        openGallery,
    }
)(Toolbar);
